module.exports = __webpack_public_path__ + "assets/209473d86b06e658429623e488412ef6.jpg";